import { render, staticRenderFns } from "./RealChallengeRanking.vue?vue&type=template&id=7a079481&"
import script from "./RealChallengeRanking.vue?vue&type=script&lang=js&"
export * from "./RealChallengeRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports